import { globalDexieDb } from "../DexiedbLib";

export interface IErrorLog {
    id?: number,
    error: any;
    time: Date;
}

export async function logError(error: any) {
    const errorLog: IErrorLog = {
        error: error,
        time: new Date(),
    }
    globalDexieDb.errorLogs.add(errorLog);
}